<template>
  <transition name="popup-fade">
    <div v-if="show" class="popup-overlay">
      <div class="popup-content">
        <h2 class="popup-title pb-1 ">{{ $t(title) }}</h2>
        <div class="popup-text">
          <p><strong>1) {{ $t('qes_not_registered_title') }}</strong></p>
          <p>{{ $t('qes_not_registered_text') }}</p>

          <p><strong>2) {{ $t('qes_registered_title') }}</strong></p>
          <ol class="custom-alpha">
            <li>{{ $t('qes_step_1') }}</li>
            <li>{{ $t('qes_step_2') }}</li>
            <li>{{ $t('qes_step_3') }}</li>
            <li>{{ $t('qes_step_4') }}</li>
          </ol>

        </div>
        <p class="popup-text"><strong>3) {{ $t('signature_instructions') }}</strong></p>

        <div class="popup-images">
          <img src="/images/skribble-explaination-1.png" alt="screenshot" />
          <img src="/images/skribble-explaination-2.png" alt="screenshot" />
        </div>

        <div class="popup-footer">
          <label class="popup-checkbox">
            <input type="checkbox" v-model="dontShowAgain" />
            {{ $t('skr_dont_show_again') }}
          </label>

          <div class="popup-actions">
            <button @click="onCancel" class="btn btn-outline-primary">{{ $t('cancel') }}</button>
            <button @click="onContinue" class="btn btn-primary">{{ $t('continue') }}</button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SkribblePopup",
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "skr_popup_title" },
  },
  data() {
    return {
      dontShowAgain: false
    };
  },
  methods: {
    onCancel() {
      this.dontShowAgain = false;
      this.$emit("cancel");
    },

    onContinue() {
      if (this.dontShowAgain) {
        localStorage.setItem("hideSkribblePopup", "true");
      }
      this.$emit("continue");
      this.dontShowAgain = false;
    }
  }
};
</script>

<style scoped>
/* Overlay */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

/* Content */
.popup-content {
  background: #fff;
  padding: 2rem;
  border-radius: 1rem;
  max-width: 90%;
  width: 95%;
  text-align: left;
  position: relative;
  box-shadow: 0 12px 30px rgba(0,0,0,0.2);
  transform: translateY(20px);
}

/* Title + Text */
.popup-title {
  margin-bottom: 0.5rem;
  font-size: 1.4rem;
  font-weight: 600;
}
.popup-text {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: #444;
}

/* Images */
.popup-images {
  display: flex;
  gap: 1rem;
  margin: 1rem 0 2rem;
  justify-content: center;
}
.popup-images img {
  width: 48%;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

/* Footer layout */
.popup-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Checkbox */
.popup-checkbox {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #333;
}
.popup-checkbox input {
  margin-right: 0.5rem;
}

/* Buttons */
.popup-actions {
  display: flex;
  gap: 0.75rem;
}

ol.custom-alpha {
  list-style: none;
  counter-reset: item;
  padding-left: 1.5em;
}

ol.custom-alpha > li {
  counter-increment: item;
  margin-bottom: 0.5em;
  padding-left: 20px;
  position: relative;
}

ol.custom-alpha > li::before {
  content: counter(item, lower-alpha) ") ";
  position: absolute;
  left: 0;
  font-weight: bold;
}

@media (max-width: 900px) {
  .popup-images {
    align-items: center;
    flex-direction: column;
  }

  .popup-images img {
    width: 90%;
    border-radius: 0.5rem;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }
}

@media (max-width: 500px) {
  .popup-footer {
    align-items: start;
    flex-direction: column-reverse;
    gap: 20px;
  }
}

</style>
